import React from "react";
import styles from "./subscription.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSearch,
  faHandPointer,
  faCreditCard,
} from "@fortawesome/free-solid-svg-icons";

const EnterprisePlanTab = ({ selectedCard }) => {
  // Hardcoded plan data
  const plan = {
    id: 10,
    heading: "Enterprise Plan",
    description: "For large organizations with advanced needs",
    details: [
      "High Volume Companies Data",
      "Trusted by enterprises around the world for tailored, scalable solutions.",
      "Perfect for Large Teams",
      "Designed to meet the demands of big teams with complex integrations and custom workflows.",
    ],
  };

  return (
    <div className={styles.subscription_pageplans}>
      <div
        key={plan.id}
        className={`${styles.singleCompanyTab} ${
          selectedCard?.id === plan.id ? styles.subscription_pageselected : ""
        }`}
      >
        {/* Left side: Company data (Flex Card) */}
        <div className={styles.singlecompanyData}>
          <h2>{plan.heading}</h2>
          <h4>{plan.description}</h4>
          <ul>
            {plan.details.map((detail, index) => {
              let iconClass = "fas fa-info-circle"; // Default icon for general details

              if (detail.includes("Quick Access")) {
                iconClass = "fas fa-clock"; // Clock for quick access
              } else if (detail.includes("Ideal For")) {
                iconClass = "fas fa-users"; // Users icon for target audience
              } else if (detail.includes("for full access")) {
                iconClass = "fas fa-key"; // Key for full access
              }

              return (
                <li key={index} className={styles.detailItem}>
                  <i className={`${iconClass} ${styles.icon}`}></i> {detail}
                </li>
              );
            })}
          </ul>
        </div>

        {/* Right side: Steps to use (Normal container) */}
        <div className={styles.singlestepsContainer}>
          <p className={styles.singlestepsContainer_para}>
            The Company Check: Engineered to Maximize Your Team's Efficiency and
            Drive Exceptional Results.
          </p>
          <p className={styles.singlestepsContainer_para}>
          Contact Sales Discover flexible pricing and customized billing options
          that work for your business.
          </p>
          <div>
          <button className={styles.singlesteps_button}>Talk To Sales</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EnterprisePlanTab;
